import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
import { Decorations } from "./decorations";
const nodeTypeToDocumentKeyMap = {
  [(Node_Type.HEADING, 1)]: "headerOne",
  [(Node_Type.HEADING, 2)]: "headerTwo",
  [(Node_Type.HEADING, 3)]: "headerThree",
  [(Node_Type.HEADING, 4)]: "headerFour",
  [(Node_Type.HEADING, 5)]: "headerFive",
  [(Node_Type.HEADING, 6)]: "headerSix",
  [Node_Type.PARAGRAPH]: "paragraph",
  [Node_Type.BLOCKQUOTE]: "blockquote",
  [Node_Type.CODE_BLOCK]: "codeBlock"
};
const nodeTypeToNodeDataKey = {
  [Node_Type.HEADING]: "headingData",
  [Node_Type.PARAGRAPH]: "paragraphData",
  [Node_Type.BLOCKQUOTE]: "blockquoteData",
  [Node_Type.CODE_BLOCK]: "codeBlockData"
};
const getTextNodes = (node) => node.type === Node_Type.BLOCKQUOTE ? node.nodes[0].nodes : node.nodes;
class TextNodeTransformer {
  constructor(node) {
    this.getDocumentStyleKey = () => {
      const level = this.node.type === Node_Type.HEADING ? this.node.headingData.level : void 0;
      return nodeTypeToDocumentKeyMap[level ? (this.node.type, level) : this.node.type];
    };
    this.node = node;
  }
  getDecorations() {
    return getTextNodes(this.node).reduce((acc, node) => acc.overrideWith(node.textData.decorations ?? []), Decorations.of([])).toDecorationArray();
  }
  getNodeStyle() {
    return this.node.style;
  }
  getTextStyle() {
    const dataKey = nodeTypeToNodeDataKey[this.node.type];
    return this.node[dataKey].textStyle || {};
  }
  toDocumentStyle() {
    const type = this.getDocumentStyleKey();
    return {
      [type]: {
        decorations: this.getDecorations(),
        nodeStyle: this.getNodeStyle(),
        lineHeight: this.getTextStyle().lineHeight
      }
    };
  }
}
export {
  TextNodeTransformer
};
//# sourceMappingURL=text-node-transformer.js.map
